import { borderRadius, media, styled } from "@iventis/styles";
import { Theme } from "@emotion/react";

export const VerticalToolbar = styled.aside<{ height?: string }>`
    display: flex;
    flex-direction: column;
    position: absolute;
    top: 115px;
    right: 14px;
    background-color: ${({ theme }: { theme: Theme }) => theme.primaryColors.subdued70};
    color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.blank};
    z-index: 3;
    border-radius: ${borderRadius.input};
    ${media.medium} {
        border-radius: 0;
        position: absolute;
        height: auto;
        top: auto;
        bottom: 0;
        right: 0;
        justify-content: space-between;
    }
    hr {
        width: 30px;
        margin: 0 7px;
        border: none;
        height: 0.25px;
        background-color: ${({ theme }: { theme: Theme }) => theme.secondaryColors.mediumAccent};
    }
`;
